import isGroupTableQuery, { getGroupIdFromTableQuery, } from "owa-group-utils/lib/utils/isGroupTableQuery";
import type { TableQuery } from "owa-mail-list-store";
import getRetentionPolicyTagsForGroup from "./getRetentionPolicyTagsForGroup";
import type { MailboxInfo } from "owa-client-types";
import type RetentionPolicyTag from "owa-service/lib/contract/RetentionPolicyTag";

export function getRetentionPolicyTagListForGroupTableQuery(tableQuery: TableQuery, mailboxInfo: MailboxInfo): RetentionPolicyTag[] {
    if (isGroupTableQuery(tableQuery)) {
        const groupId = getGroupIdFromTableQuery(tableQuery);
        return getRetentionPolicyTagsForGroup(mailboxInfo, groupId);
    }
    
    return [];
}
